<hs-bulk-clearwater-transactions-grid
  [isLoading]="isLoading"
  [updateStatuses]="updateStatuses$ | async"
  [data]="data"
  [transactionsLimitExceeded]="transactionsLimitExceeded"
  [maxTransactions]="maxTransactions"
  (bulkEditTxAction)="bulkEditTx($event)"
  (bulkCopyTxAction)="bulkCopyTx($event)"
  (clearAction)="clearAction($event)"
  (clearAndSetPostDateAction)="clearAndSetPostDateAction($event)"
  (unclearAction)="unclearAction($event)"
  (deleteAction)="deleteAction($event)"
  (deleteAndIgnoreAction)="deleteAndIgnoreAction($event)"
  (deleteAndHoldAction)="deleteAndHoldAction($event)"
  [(isSearchPopoverShown)]="isSearchPopoverShown"
  (clearTable)="clearTable()"
  (cancel)="onCancelRequest()"
>
  <hs-find-transactions-popover
    (find)="onDownloadSubmit($event)"
    (getBulkTxByTranIds)="onFind($event)"
  ></hs-find-transactions-popover>
</hs-bulk-clearwater-transactions-grid>
